
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"5.02","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"14.07","fill":"#000","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"20.1","height":"5.53","x":"1","y":"2.9","fill":"#FAB4CD","fill-rule":"nonzero","rx":"1.32"}}),_c('path',{attrs:{"stroke":"#000","stroke-linecap":"round","stroke-linejoin":"bevel","d":"M11.55 22H2.96A1.96 1.96 0 011 20.04V4.86A1.96 1.96 0 012.96 2.9h16.18a1.96 1.96 0 011.96 1.96V11"}}),_c('path',{attrs:{"fill":"#FFC511","fill-rule":"nonzero","d":"M11 15c1.257 0 2.275-1.006 2.275-2.25S12.257 10.5 11 10.5s-2.275 1.006-2.275 2.25S9.743 15 11 15zm-4.55-.643c.717 0 1.3-.576 1.3-1.286 0-.709-.583-1.285-1.3-1.285-.717 0-1.3.576-1.3 1.285 0 .71.583 1.286 1.3 1.286zm.039 3.214a2.944 2.944 0 011.527-2.197A1.305 1.305 0 007.1 15H5.8c-.717 0-1.3.577-1.3 1.286v.643c0 .355.29.642.65.642h1.339zM11.5 18c0-1.278.457-2.176.225-2.121a3.148 3.148 0 01-2.116-.236H9.44c-1.292 0-2.34 1.036-2.34 2.314v.579a.97.97 0 00.975.964H11c.428 0 .594-.5.5-1.5z"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","stroke":"#000","d":"M18.094 23.422c1.417 0 2.71-.537 3.685-1.417a.267.267 0 00.01-.387l-.879-.88a.266.266 0 00-.363-.012 3.727 3.727 0 11-2.42-6.53c.94.008 1.826.363 2.51 1.004l-.925.926a.533.533 0 00.376.909h2.973a.533.533 0 00.533-.532v-2.974a.533.533 0 00-.909-.376l-.792.792a5.486 5.486 0 00-3.79-1.523 5.51 5.51 0 00-5.51 5.5 5.5 5.5 0 005.5 5.5z"}}),_c('path',{attrs:{"stroke":"#000","d":"M1 8.43h20.1"}})])])
          )
        }
      }
    